import clsx from 'clsx';
import {FieldError} from 'react-hook-form';
import {SoopIcon} from '@soop-ui/soop-ui';
import styles from '@/components/help/common/FormContainer/FormContainer.module.scss';

interface FormErrorProps {
  error?: FieldError;
  className?: string;
}

const FormError = ({error, className}: FormErrorProps) => {
  if (!error?.message) {
    return null;
  }

  return (
    <div className={clsx(styles.errorTextWrapper, className)}>
      <SoopIcon
        name='icoExclamationRed'
        width='14'
        height='14'
        className={styles.errorIcon}
      />
      <p>{error.message}</p>
    </div>
  );
};

export default FormError;
